"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createfetchUnlessCached = createfetchUnlessCached;

var _isomorphicFetch = require("isomorphic-fetch");

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _lscache = require("lscache");

var _lscache2 = _interopRequireDefault(_lscache);

var _objectHash = require("object-hash");

var _objectHash2 = _interopRequireDefault(_objectHash);

var _requestidlecallback = require("requestidlecallback");

var _requestidlecallback2 = _interopRequireDefault(_requestidlecallback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isClient = function isClient() {
  return typeof window !== "undefined";
};

// 10 hours
var LSCACHE_TIMEOUT_IN_MINUTES = 10 * 60;

function createfetchUnlessCached() {
  var cacheDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LSCACHE_TIMEOUT_IN_MINUTES;
  var fetchIfIdle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return function fetchUnlessCached() {
    for (var _len = arguments.length, fetchOpts = Array(_len), _key = 0; _key < _len; _key++) {
      fetchOpts[_key] = arguments[_key];
    }

    /**
     * We only do caching on the client site
     */

    if (isClient()) {
      var RESOURCE_HASH = (0, _objectHash2.default)(fetchOpts);
      var cachedResponse = _lscache2.default.get(RESOURCE_HASH);

      /**
       * const fetchDataFromServer - Fetch data from the api
       * Then set the data inside the cache.
       * Return the reponse object
       * @return {Object}  reponse
       */

      var fetchDataFromServer = function fetchDataFromServer() {
        return _isomorphicFetch2.default.apply(undefined, fetchOpts).then(function (response) {
          return response.json();
        }).then(function (response) {
          _lscache2.default.set(RESOURCE_HASH, response, cacheDuration);
          return response;
        });
      };

      /**
       * if - cachedResponse exists for the given key
       *
       * @param  {type} cachedResponse
       */

      if (cachedResponse) {
        /**
         * return the promise containing the saved data
         * but behind the scenes fetch new data. We can use this data the next time it is requested
         * This is async . So the response return is immediate
         */
        if (fetchIfIdle) {
          _requestidlecallback2.default.request(function () {
            /**
             * Client is idle. Now fetch the response and cache
             */
            fetchDataFromServer();
          });
        }

        /**
         * Resolve the cachedResponse first and then fetch in the idle callback at a later time
         */
        return Promise.resolve(cachedResponse);
      } else {
        return fetchDataFromServer();
      }
    } else {
      /**
       * Just do fetch on the server
       */

      return _isomorphicFetch2.default.apply(undefined, fetchOpts).then(function (response) {
        return response.json();
      });
    }
  };
}

var fetchUnlessCached = createfetchUnlessCached();
exports.default = fetchUnlessCached;